import { DirettissimeCard } from 'components/cards/direttissimeCard';
import { Carousel } from 'components/carousel/Carousel';
import { Wrapper } from 'components/wrapper/Wrapper';
import { AmbienteContext } from 'context/Ambiente';
import { useGetDirettissimeQuery } from 'features/api/sportApiSlice';
import React, { useEffect } from 'react';
import { isServerSide } from 'utility/constant';
import { isTruthy } from 'utility/functions';
import styles from './DirettissimeCarousel.module.scss';

export type DirettissimeCarouselProps = {
  title: string;
  className: string;
  slug: string;
  isEnabledPromo?: boolean;
};

export const DirettissimeCarousel = ({ title, slug, isEnabledPromo }: DirettissimeCarouselProps) => {
  const { data } = useGetDirettissimeQuery(slug, {
    pollingInterval: 300000,
    skip: isServerSide,
    refetchOnMountOrArgChange: true,
  });

  if (!isTruthy(data?.direttissime?.length)) {
    return <React.Fragment key={`${title}-${slug}`} />;
  }

  return (
    <Wrapper noPaddingLeft noPaddingRight className="backgroundElement" bgColorTransparent>
      <AmbienteContext.Provider value={{ pathScommessa: ['sport', 'templateDirettissime'], ambiente: 'sport' }}>
        <Carousel
          title={title}
          cardContainerClassName={styles.direttissimeCardContainer}
          classNameTitle={styles.paddingLeft}
        >
          {data!.direttissime!.map((item) => (
            <DirettissimeCard
              key={item.scommessaKey}
              direttissimaKey={item.scommessaKey}
              esitoKey={item.esitoKey}
              isEnabledPromo={isEnabledPromo}
            />
          ))}
        </Carousel>
      </AmbienteContext.Provider>
    </Wrapper>
  );
};
